"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var isAccepted = function isAccepted(message) {
  return function (_ref) {
    var field = _ref.field;
    var isValid = field && (field.value === 'accepted' || field.value === true);
    return [isValid, message || 'Field value must be true or equal to `accepted`'];
  };
};

var _default = isAccepted;
exports.default = _default;
//# sourceMappingURL=isAccepted.js.map